<template>
  <layout-main-inner title="商品备案详情">
    <!-- <template slot="append">
      <span
        v-if="userPermission.SUPERVISE || userPermission.OPERATE"
        style="color:#888">({{ productInfo.vendorName }})</span>
    </template> -->
    <el-button
      slot="action"
      type="primary"
      :loading="loading"
      @click="edit">编辑</el-button>
    <el-form
      disabled
      label-position="top">
      <layout-card-wrap
        v-loading="loading"
        hasHeaderSlot>
        <template slot="title">基本信息</template>
        <el-row
          type="flex"
          :gutter="20">
          <el-col :span="8">
            <el-form-item label="商品名称:">
              <span>{{ productInfo.productName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品编号:">
              <span>{{ productInfo.productNumber || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品规格:">
              <span>{{ productInfo.productNameRemark || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品品种:">
              <span>{{ productInfo.categoryName || '-' }}</span>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="商品系列:">
              <span>{{ productInfo.productLineName || '-' }}</span>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="商品图片:">
              <upload-image
                v-model="productInfo.productImages"
                :limit="5"
                :autoCropWidth="300"
                :autoCropHeight="180"
                status="detail" />
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>
      <layout-card-wrap
        v-loading="loading"
        hasHeaderSlot
        style="margin-top:8px">
        <template slot="title">其他信息</template>
        <el-row
          type="flex"
          :gutter="20">
          <template v-for="(item, index) in productInfo.baseFields">
            <el-col
              :key="item.name"
              :span="item.type==='IMAGE' ? 24 : 8">
              <smart-form
                :item="item"
                status="detail"
                :vendorId="productInfo.vendorId"
                :prop="'baseFields.' + index + '.fieldValue'" />
            </el-col>
          </template>
          <template v-for="(item, index) in productInfo.extraFields">
            <el-col
              :key="item.name"
              :span="item.type==='IMAGE' ? 24 : 8">
              <smart-form
                :item="item"
                status="detail"
                :vendorId="productInfo.vendorId"
                :prop="'extraFields.' + index + '.fieldValue'" />
            </el-col>
          </template>
        </el-row>
      </layout-card-wrap>
    </el-form>
    <!-- <template slot="footer">
      <el-button
        v-if="userPermission.ENT || userPermission.OPERATE"
        type="primary"
        :loading="loading"
        @click="edit">编辑</el-button>
    </template> -->
  </layout-main-inner>
</template>
<script>
// import TradeRadioBox from './busi/trade-radio-box.vue'
// import CodingRadioBox from './busi/coding-radio-box.vue'
// import VendorLabelSelect from './busi/vendor-label-select.vue'
// import VendorCategorySelect from './busi/vendor-category-select.vue'
import UploadImage from '@/components/public/upload-image-new.vue'
import '@/components/business/custom-form/index'
import TemplateFormat from '@/utils/templateFormat'
import { mapState } from 'vuex'
export default {
  name: 'ProductDetail',
  components: { UploadImage },
  data() {
    return {
      loading: false,
      productInfo: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  mounted() {
    this.getproduct({
      vendorId: this.$route.query.vendorId,
      productId: this.$route.query.productId
    })
  },
  methods: {
    getproduct(config) {
      this.loading = true
      this.$store.dispatch('product/getproduct', {
        payload: config,
        success: (res) => {
          this.loading = false
          res.data.productImages = res.data.productImages ? res.data.productImages.split(',').map(item => ({ url: item })) : []
          res.data.baseFields = TemplateFormat.editTemplateFormat(res.data.baseFields)
          res.data.extraFields = TemplateFormat.editTemplateFormat(res.data.extraFields || [])
          this.productInfo = res.data
        },
        fail: () => {
          this.loading = false
          this.productInfo = {}
        }
      })
    },
    edit() {
      this.$router.push(`/product-update?vendorId=${this.$route.query.vendorId}&productId=${this.$route.query.productId}`)
    }
  }
}
</script>
